import { fetchSwiper } from '../dynamic-modules';

export function createArrows(container) {
    const arrow = `
        <svg width="26" height="8" viewBox="0 0 26 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25 4.5a.5.5 0 100-1v1zM.646 3.646a.5.5 0 000 .708l3.182 3.182a.5.5 0 00.707-.708L1.707 4l2.828-2.828a.5.5 0 00-.707-.708L.646 3.646zM25 3.5H1v1h24v-1z" fill="#B8937A"/>
        </svg>
    `;

    container.innerHTML = `
        <button class="slider__arrow slider__arrow--prev" aria-label="Предыдущий слайд">${arrow}</button>
        <button class="slider__arrow slider__arrow--next" aria-label="Следующий слайд">${arrow}</button>
    `;
}

async function init() {
    const container = document.querySelector('.js-slider');

    if (container) {
        let slides = [];
        const wrapper = Array.from(container.children).find((el) => el.classList.contains('swiper-wrapper'));
        let navContainer;

        if (wrapper) {
            const containerChildren = Array.from(container.children);
            const wrapperChildren = Array.from(wrapper.children);
            navContainer = containerChildren.find((el) => el.classList.contains('swiper-navigation'));
            slides = wrapperChildren.filter((el) => el.classList.contains('swiper-slide'));
        }

        if (slides.length > 2) {
            const { default: Swiper, Navigation, Lazy } = await fetchSwiper();
            Swiper.use(Navigation);
            Swiper.use(Lazy);

            createArrows(navContainer);

            const swiper = new Swiper(container, {
                loop: true,
                centeredSlides: true,
                noSwipingSelector: '.swiper--no-swiping',
                slidesPerView: 'auto',
                edgeSwipeThreshold: 80,
                touchEventsTarget: 'wrapper',
                speed: 1000,
                shortSwipes: false,
                longSwipesMs: 50,
                longSwipesRatio: 0.05,
                navigation: {
                    prevEl: navContainer.querySelector('.slider__arrow--prev'),
                    nextEl: navContainer.querySelector('.slider__arrow--next'),
                },
                // pagination: {
                //     el: '.swiper-pagination',
                //     type: 'bullets',
                //     clickable: true,
                //     renderBullet: (index, className) => `
                //         <button class="slider-pagination__bullet ${className}"></button>
                //     `,
                // },
                lazy: {
                    loadPrevNext: true,
                },
            });
        }
    }
}

export default { init };
